<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

<ng-container *ngIf="!isLoading && credentials">

  <!-- UPN Row -->
  <div class="creds-conn-item">
    <span class="creds-conn-label">
      <mat-icon class="creds-conn-icon">alternate_email</mat-icon>Login Email (UPN)
    </span>
    <div class="creds-conn-value-row">
      <code class="creds-mono">{{ credentials.userPrincipalName }}</code>
      <button mat-icon-button class="creds-copy-btn"
              matTooltip="Copy login email"
              (click)="copyToClipboard(credentials.userPrincipalName, 'Login email')">
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>
  </div>

  <!-- TAP Row -->
  <div class="creds-conn-item">
    <span class="creds-conn-label">
      <mat-icon class="creds-conn-icon">password</mat-icon>Temporary Access Pass
    </span>
    <div class="creds-conn-value-row">
      <code class="creds-mono creds-password-field">
        {{ tapVisible ? credentials.temporaryAccessPass : '••••••••••' }}
      </code>
      <button mat-icon-button class="creds-copy-btn"
              [matTooltip]="tapVisible ? 'Hide TAP' : 'Show TAP'"
              (click)="toggleTapVisibility()">
        <mat-icon>{{ tapVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <button mat-icon-button class="creds-copy-btn"
              matTooltip="Copy TAP"
              (click)="copyToClipboard(credentials.temporaryAccessPass, 'TAP')">
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>
  </div>
</ng-container>
